export const IMAGES_PATH = 'https://fiverr-res.cloudinary.com/image/upload/v1584948052/general_assets/categories/nsc_01';
